import React, { Component } from 'react';
import Select from 'react-select';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';

import {
    ROOT_URL, ROOT_API_URL, companyCodeTitle, isABBLE, isOCM, isSH, isGGI, isHO, isJRC,
    isHMM, isLE, isSKH, isCPG, isARC, isSUN, isLAP, isGFD, isVAK, isOLG, isABCFF,
    isLMH, isBRO, isSDR, isCRW, isSC
  } from '../../actions/root_url';


export class DiscountChangeModal extends Component {
    constructor() {
        super();
        this.state = {
            discount: 0,
            savings: 0,
        }
    }

    componentDidMount() {
        this.setState({ discount: this.props.SODiscount, savings: this.props.SOSavings });
    }

    handleOnConfirm = (e) => {
        e.preventDefault();
        if (!this.state.discount) {
            this.setState({discount: 0});
        }
        if (!this.state.savings) {
            this.setState({savings: 0});
        }
        this.props.onDiscountSavingsConfirm(this.state.discount, this.state.savings);
    }

    onChangeDiscount = (e) => {
        this.setState({ discount: e.target.value, savings: 0 });
    }

    onChangeSavings = (e) => {
        this.setState({ savings: e.target.value, discount: 0 });
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={6}>
                        <label><Translate value="discount" />(%) {(isLMH || isBRO || isSDR || isCRW || isSC) && <label style={{color: 'red', fontSize: '11px'}}>Applied Before Tax</label>}</label>
                        <Input
                            type="text"
                            value={this.state.discount}
                            onChange={this.onChangeDiscount}
                        />
                    </Col>
                    <Col sm={6}>
                        <label><Translate value="savings" />($) {(isLMH || isBRO || isSDR || isCRW || isSC) && <label style={{color: 'red', fontSize: '11px'}}>Applied After Tax</label>}</label>
                        <Input
                            type="text"
                            value={this.state.savings}
                            onChange={this.onChangeSavings}
                        />
                    </Col>
                </Row>
                <Row className="centerStyle" style={{ marginTop: '25px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="primary"
                        onClick={(e) => { this.handleOnConfirm(e); }}
                    >
                        <Translate value="confirm" />
                    </Button>
                </Row>
            </div>
        );
    }
}

export default DiscountChangeModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/discountChangeModal.jsx